import { DocumentState } from '../../../common';
import { colors } from '../../theme/colors';
import { en } from '../../theme/languages/en';

export interface BadgeData {
  label: string;
  color: string;
  backgroundColor: string;
  borderColor?: string;
}

export const getDataByStatus = (documentState: DocumentState): BadgeData => {
  switch (documentState) {
    case DocumentState.PAID:
      return {
        label: en.paid,
        color: colors.success700,
        backgroundColor: colors.success50,
      };
    case DocumentState.DRAFT:
      return {
        label: en.draft,
        color: colors.neutral700,
        backgroundColor: colors.neutral100,
      };
    case DocumentState.CANCELED:
      return {
        label: en.canceled,
        color: colors.white,
        backgroundColor: colors.destructive,
      };
    case DocumentState.COLLECTING_INFO:
    case DocumentState.REVIEW_MISSING_DATA:
    case DocumentState.REVIEW_READY_TO_SEND:
    case DocumentState.FINALIZED:
    case DocumentState.SENT:
    case DocumentState.LATE:
      return {
        label: en.unPaid,
        color: colors.white,
        backgroundColor: colors.black,
      };
  }
};
